import { useState } from "react";
import Partner from "../models/Partner";
import {
  FaEllipsisH,
  FaEye,
  FaEdit,
  FaTrash,
} from "react-icons/fa";

export function Input({
  label,
  name,
  value,
  onChange,
  required,
  type = "text",
}: {
  label: string;
  name: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  required?: boolean;
  type?: string;
}) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-slate-700">
        {label}

        {required && (
          <span className="ml-1 text-red-500">*</span>
        )}
      </label>

      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="h-11 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-50"
      />
    </div>
  );
}

export function StatCard({
  title,
  value,
//   subtitle,
  icon,
}: {
  title: string;
  value: string;
//   subtitle: string;
  icon: React.ReactNode;
}) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">

      <div className="flex items-start justify-between">

        <div>
          <p className="text-sm font-medium text-slate-500">
            {title}
          </p>

          <p className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">
            {value}
          </p>
        </div>

        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
          {icon}
        </div>

      </div>
    </div>
  );
}

interface PartnerMenuProps {
  partner: Partner;
  onAction: (action: "view" | "edit" | "delete", partner: Partner) => void;
}

export function PartnerMenu({
  partner,
  onAction,
}: PartnerMenuProps) {
  const [open, setOpen] = useState(false);

  const handleAction = (
    action: "view" | "edit" | "delete"
  ) => {
    setOpen(false);
    onAction(action, partner);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex h-8 w-8 items-center justify-center rounded-md text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
        aria-label="Partner actions"
        aria-expanded={open}
      >
        {FaEllipsisH({ size: 13 })}
      </button>

      {open && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setOpen(false)}
          />

          <div className="absolute right-0 top-9 z-50 w-32 rounded-lg border border-slate-200 bg-white p-1 shadow-lg shadow-slate-900/10">
            
            {/* Details */}
            <button
              type="button"
              onClick={() => handleAction("view")}
              className="flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-left text-xs font-medium text-slate-600 transition hover:bg-slate-50 hover:text-slate-900"
            >
              <span className="text-slate-400">
                {FaEye({ size: 11 })}
              </span>
              Details
            </button>

            {/* Edit */}
            <button
              type="button"
              onClick={() => handleAction("edit")}
              className="flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-left text-xs font-medium text-slate-600 transition hover:bg-slate-50 hover:text-slate-900"
            >
              <span className="text-slate-400">
                {FaEdit({ size: 11 })}
              </span>
              Edit
            </button>

            <div className="my-1 border-t border-slate-100" />

            {/* Delete */}
            <button
              type="button"
              onClick={() => handleAction("delete")}
              className="flex w-full items-center gap-2 rounded-md px-2.5 py-2 text-left text-xs font-medium text-red-600 transition hover:bg-red-50"
            >
              <span className="text-red-400">
                {FaTrash({ size: 11 })}
              </span>
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  );
}